import { render, staticRenderFns } from "./PopupRiskInfo_5x4_3.vue?vue&type=template&id=3efb8197&scoped=true"
import script from "./PopupRiskInfo_5x4_3.vue?vue&type=script&lang=js"
export * from "./PopupRiskInfo_5x4_3.vue?vue&type=script&lang=js"
import style0 from "./PopupRiskInfo_5x4_3.vue?vue&type=style&index=0&id=3efb8197&prod&lang=scss&scoped=true"
import style1 from "./PopupRiskInfo_5x4_3.vue?vue&type=style&index=1&id=3efb8197&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efb8197",
  null
  
)

export default component.exports